import type { SxProps } from "@mui/material";

export const contentStyle: SxProps = () => ({
  flex: 1,
  background: "var(--bg-color)",
});

export const contentBodyStyle: SxProps = () => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  width: "100%",
  maxWidth: "1280px",
  minHeight: "100%",
  boxSizing: "border-box",
  margin: "0 auto",
});

export const contentBodyInnerStyle: SxProps = () => ({
  position: "relative",
  display: "flex",
  flex: 1,
  flexDirection: "column",
  px: 3,
  wordBreak: "break-word",
});
